//=================================== CHANGE ENVIRONMENT ==================================
const option = 'Production'
//=========================================================================================

function env(env) {
    switch (env) {
        case 'Production':
            return ['https://apireglaspro.portalcnc.site:459/rules/api',env,'grey darken-1','http://des-reglas.mitur.gob.do/']
        default:
            return ''
    }
}

try {
    module.exports ={
        api:    env(option)[0],
        env:    env(option)[1],
        color:  env(option)[2],
        qrApi: env(option)[3],
        SECRET_TOKEN: 'XXDzwjrxat1NDBbp'
    }
} catch (e) {}
